// extracted by mini-css-extract-plugin
export default {"checkbox":"BlockStudentModal_checkbox__vI5YW"};